import { render } from "./ConsentModal.vue?vue&type=template&id=4b8aff2a&scoped=true"
import script from "./ConsentModal.vue?vue&type=script&lang=js"
export * from "./ConsentModal.vue?vue&type=script&lang=js"

import "./ConsentModal.vue?vue&type=style&index=0&id=4b8aff2a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b8aff2a"]])

export default __exports__